import { FormikValues } from 'formik'

export interface FormBankingGroupRating extends FormikValues {
  shortRating: string
  longRating: string
  startDate: Date
}

export const bankingGroupRatingInitialValues: FormBankingGroupRating = {
  shortRating: null,
  longRating: null,
  startDate: null,
}
